import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const MatrizFiliais = () => {
  const locations = [
    {
      name: 'Vilhena',
      state: 'RO',
      type: 'Matriz',
      manager: 'Abel Cândido',
      whatsapp: '5569996010407',
      image: 'https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jtbzkk4m_ChatGPT%20Image%2025%20de%20jun.%20de%202026%2C%2016_02_00.png',
      address: 'Av. Jô Sato, 1953',
      bairro: 'Novo Tempo, Vilhena - RO',
      cep: 'CEP 76982-131',
      phone: '(69) 3321-4548',
      mapLink: 'https://maps.app.goo.gl/hgTRX248WvQJjyaLA',
      highlight: true,
    },
    {
      name: 'Cacoal',
      state: 'RO',
      type: 'Filial',
      manager: 'Luiz Augusto Catanio',
      whatsapp: '5569992753333',
      image: 'https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/urnlwo1g_cacoal%202026.jpg',
      address: 'Av. Castelo Branco, 18592',
      bairro: 'Princesa Isabel, Cacoal - RO',
      cep: 'CEP 76964-012',
      phone: '(69) 3321-4548',
      mapLink: 'https://maps.app.goo.gl/jPycQDnJQbfKXL6a8',
    },
    {
      name: 'Pontes e Lacerda',
      state: 'MT',
      type: 'Filial',
      manager: 'Clemilson Luiz',
      whatsapp: '5565996008340',
      image: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e2qbu7le_14%20i.jpg',
      address: 'Av. Valdemar Bittencourt, 290B',
      bairro: 'Jardim Bela Vista 3, Pontes e Lacerda - MT',
      cep: 'CEP 78250-000',
      phone: '(69) 3321-4548',
      mapLink: 'https://www.google.com/maps/search/?api=1&query=Av+Valdemar+Bittencourt+290B+Jardim+Bela+Vista+Pontes+e+Lacerda+MT',
    },
    {
      name: 'São Miguel do Guaporé',
      state: 'RO',
      type: 'Filial',
      manager: 'Baltazar Fernandes',
      whatsapp: '5569984474778',
      image: 'https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jg8avp20_smg%202026.jpg',
      address: 'Av. Aluízio Pinheiro, 610',
      bairro: 'Liberdade, São Miguel do Guaporé - RO',
      cep: 'CEP 76932-000',
      phone: '(69) 3321-4548',
      mapLink: 'https://www.google.com/maps/search/?api=1&query=Av+Aluizio+Pinheiro+610+Liberdade+Sao+Miguel+do+Guapore+RO',
    },
    {
      name: 'Ariquemes',
      state: 'RO',
      type: 'Filial',
      manager: 'Alexandre Fetsch',
      whatsapp: '5569984617269',
      image: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e1je7ftn_12%20i.jpg',
      address: 'BR-364, 3839',
      bairro: 'Marechal Dutra, Ariquemes - RO',
      cep: 'CEP 76877-225',
      phone: '(69) 3321-4548',
      mapLink: 'https://maps.app.goo.gl/EtnENuXVwYmpzZB26',
    },
    {
      name: 'Cerejeiras',
      state: 'RO',
      type: 'Filial',
      manager: 'Eliel Felipe Schmitz',
      whatsapp: '5569993751423',
      image: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/ui9bnqne_11%20i.jpg',
      address: 'Av. das Nações, 3369',
      bairro: 'Maranata, Cerejeiras - RO',
      cep: 'CEP 76997-000',
      phone: '(69) 3321-4548',
      mapLink: 'https://maps.app.goo.gl/BNKZ63YMrEmU9x3G9',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-r from-blue-600 to-green-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-6xl font-bold mb-6">MATRIZ E FILIAIS</h1>
          <p className="text-2xl max-w-3xl mx-auto">
            Estamos presentes em 6 unidades em RO e MT
          </p>
        </div>
      </section>

      {/* Locations Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {locations.map((location, index) => (
              <div
                key={index}
                className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 ${
                  location.highlight ? 'ring-4 ring-green-600' : ''
                } ${location.isNew ? 'ring-4 ring-yellow-400' : ''}`}
              >
                {/* Image with label */}
                <div className="relative h-52">
                  <img
                    src={location.image}
                    alt={location.name}
                    className="w-full h-full object-cover"
                  />
                  {location.highlight && (
                    <>
                      <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                        MATRIZ
                      </div>
                    </>
                  )}
                  {location.isNew && (
                    <div className="absolute top-4 right-4 bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-sm font-bold animate-pulse">
                      NOVA 2025
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    {location.name}
                  </h3>
                  <p className="text-green-600 font-semibold mb-1">{location.type}</p>
                  {location.manager && (
                    <p className="text-sm text-blue-700 font-semibold mb-4" data-testid={`mf-manager-${location.name.toLowerCase().replace(/\s+/g, '-')}`}>
                      Gerente: {location.manager}
                    </p>
                  )}

                  <div className="space-y-3">
                    <div className="flex items-start space-x-3 text-gray-600">
                      <MapPin className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                      <div>
                        <p className="text-sm">{location.address}</p>
                        {location.bairro && <p className="text-sm">{location.bairro}</p>}
                        {location.cep && <p className="text-xs text-gray-500">{location.cep}</p>}
                      </div>
                    </div>
                    {location.phone && (
                      <div className="flex items-center space-x-3 text-gray-600">
                        <Phone className="w-5 h-5 text-green-600 flex-shrink-0" />
                        <p className="text-sm">{location.phone}</p>
                      </div>
                    )}
                  </div>

                  <div className="mt-6 grid grid-cols-1 gap-2">
                    {location.whatsapp && (
                      <a
                        href={`https://wa.me/${location.whatsapp}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`mf-whatsapp-${location.name.toLowerCase().replace(/\s+/g, '-')}`}
                        className="w-full text-center bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg transition-colors"
                      >
                        FALAR COM GERENTE
                      </a>
                    )}
                    {location.mapLink && (
                      <a
                        href={location.mapLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full text-center bg-white border border-blue-600 text-blue-700 hover:bg-blue-50 font-semibold py-3 rounded-lg transition-colors"
                      >
                        VER NO MAPA
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6">Nossa Estrutura</h2>
              <p className="text-lg leading-relaxed mb-4">
                Para garantir agilidade, contamos com a Cultivar Log, nossa transportadora própria de apoio às operações, atendendo de perto os produtores.
              </p>
              <p className="text-lg leading-relaxed">
                A gestão de todas as operações está sob o Grupo SODIN, que fortalece nossa estratégia e expansão.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 text-center">
                <div className="text-5xl font-bold mb-2">6</div>
                <p className="text-sm">Unidades</p>
              </div>
              <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 text-center">
                <div className="text-5xl font-bold mb-2">13</div>
                <p className="text-sm">Anos de História</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MatrizFiliais;